<template>
  <a
    v-if="show"
    class="block py-1.5 px-3 text-gray-600 hover:text-gray-800"
    href=""
    @click.stop.prevent="folderClick('move')">{{$t('Move')}}</a>
</template>

<script>
import MoveCopy from '../../../mixins/MoveCopy'

export default {
  mixins: [MoveCopy],
  emits: ['onselect'],
  props: ['item'],
  data() {
    return {}
  },
  computed: {
    show () {
      return this.item.can_edit
    },
  },
}
</script>

<style lang="scss" scoped></style>
